module.exports = __webpack_public_path__ + "static/media/loyalty-rewards-program.5c59b011.png";